import { Container, Paper } from '@mui/material';

import AllIncidentsTable from '../components/patients/AllIncidentsTable';

const IncidentsSummary = ({ role }) => (
  <Container maxWidth="xl" sx={{ pt: 4, pb: 4 }}>
    <Paper elevation={3} sx={{ padding: 3, pt: 2 }}>
      <AllIncidentsTable role={role} />
    </Paper>
  </Container>
);

export default IncidentsSummary;
